export type CapacityTone = 'ok' | 'warning' | 'danger';

export const CAPACITY_WARN = 80;
export const CAPACITY_DANGER = 95;

export function capacityTone(percent: number): CapacityTone {
  if (!Number.isFinite(percent)) return 'ok';
  if (percent >= CAPACITY_DANGER) return 'danger';
  if (percent >= CAPACITY_WARN) return 'warning';
  return 'ok';
}
